// extracted by mini-css-extract-plugin
export var card = "_87-c";
export var checkmark = "_87-k";
export var childrenContainer = "_87-6";
export var container = "_87-b";
export var disabled = "_87-9";
export var disabledChildren = "_87-a";
export var focused = "_87-1";
export var gray = "_87-s";
export var green = "_87-p";
export var icon = "_87-g";
export var iconWrapper = "_87-8";
export var imageCircle = "_87-u";
export var large = "_87-5";
export var lg = "_87-j";
export var listItemContainer = "_87-0";
export var md = "_87-i";
export var medium = "_87-4";
export var menu = "_87-f";
export var nonInteractiveBadge = "_87-m";
export var red = "_87-q";
export var rightArea = "_87-7";
export var sectionContainer = "_87-e _87-b";
export var selected = "_87-d";
export var sm = "_87-h";
export var small = "_87-3";
export var statusDot = "_87-o";
export var statusDotContainer = "_87-n";
export var text = "_87-l";
export var transparent = "_87-t";
export var xs = "_87-2";
export var yellow = "_87-r";